import React__default from 'react';
import { ContextProvider } from '../ContextProvider/providers.js';
import { AuthForm } from './view.js';

const AuthFormWithContextProvider = React__default.forwardRef((props, ref) => {
    const { metaInfo, userManager, ...rest } = props;
    return (React__default.createElement(ContextProvider, { metaInfo: metaInfo, userManager: userManager },
        React__default.createElement(AuthForm, { ...rest, ref: ref })));
});

export { AuthFormWithContextProvider };
//# sourceMappingURL=providers.js.map
